import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/expediente/getExpediente.php';

export default function getExpediente({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}